import { dateTimeFunction, getTimeDateString } from "utils/date"

const suggestedTimesTransformer = response => {
  const options = response?.data?.map(item => ({
    label: `${getTimeDateString(item?.startTime, true, false, true)} - ${getTimeDateString(
      item?.endTime,
      true,
      false,
      true
    )}`,
    value: [item?.startTime, item?.endTime],
  }))
  return options
}

export default suggestedTimesTransformer
